import React from 'react';
import { urlManager } from '../../../../../../Utils/URL/URLManager';
import { LinkStyled } from '../../../../../../Components/Links/BaseLink/BaseLink.styles';
import { AdditionalSectionStyled } from '../../../../../../Components/Forms/Auth';

interface Props {}

export const AdditionalSection: React.FC<Props> = () => {
  return (
    <AdditionalSectionStyled>
      <LinkStyled to={urlManager.signIn()}>I have account...</LinkStyled>
      <LinkStyled to={urlManager.forgotPassword()}>Forgot password</LinkStyled>
    </AdditionalSectionStyled>
  );
};
